export default __webpack_public_path__ + "static/media/rain.f544daaf.mp3";